<template>
    <div class="section-box">
        <el-row class="row-bg">
            <el-col :span="12" style="text-align: left;">
                <template v-if="!(typeof(actionData.dataFramehy_add) != 'undefined'&&!actionData.dataFramehy_add)">
                    <el-button size="medium" type="primary" icon="el-icon-plus" @click="addIndustryBox">添加</el-button>
                </template>
                <span v-else style="color: #f9fafc;">空</span>
            </el-col>
            <el-col :span="12" style="text-align: right;">
                <el-button size="medium" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="medium" type="success" @click="handleReset">重置</el-button>
            </el-col>
        </el-row>

        <!-- 列表 -->
        <el-table
            :stripe="true"
            :data="tableData"
            style="width: 100%"
            height="670"
            border
            v-loading="listLoading" 
        >
            <!-- eslint-disable  -->
            <el-table-column label="序列">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.SortNo" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.SortNo}}</span>
                    </template>
                </el-table-column>
            </el-table-column>     
            <el-table-column label="行业名称">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.IndustryName" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IndustryName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="ID">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model="form.Id" placeholder="输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.Id || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="一级类别">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.IsFirstLevel" placeholder="请选择" style="width: 100%;">
                            <el-option :value="1" label="是"></el-option>
                            <el-option :value="0" label="否"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IsFirstLevel?'是':'否'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="备注" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.Remark || '--'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="是否有效">
                <el-table-column show-overflow-tooltip width="200">
                    <template slot="header" slot-scope="scope">
                        <el-select size="mini" v-model="form.IsAvailable" placeholder="请选择" style="width: 100%;">
                            <el-option :value="1" label="有效"></el-option>
                            <el-option :value="0" label="无效"></el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.IsAvailable?'有效':'无效'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" width="280" fixed="right">
                <template slot-scope="scope">
                    <template v-if="!(typeof(actionData.dataFramehy_edit) != 'undefined'&&!actionData.dataFramehy_edit)">
                        <el-button size="mini" type="primary" @click="editIndustryBox(scope.row)">编辑</el-button>
                    </template>
                    <template v-if="!(typeof(actionData.dataFramehy_isrelease) != 'undefined'&&!actionData.dataFramehy_isrelease)">
                        <el-button v-if="scope.row.IsAvailable" size="mini" type="danger" @click="updateIndustry(scope.row.Id,false)">作废</el-button>
                        <el-button v-else size="mini" type="warning" @click="updateIndustry(scope.row.Id,true)">恢复</el-button>
                    </template>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="form.PageIndex"
                    :page-sizes="[10, 20, 50, 100, 200]"
                    :page-size="form.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
            :visible.sync="industryShow" 
            :title="industryTitle" 
            :close-on-click-modal="false"
            width="600px" 
            ref="dialog" 
        >
            <el-form label-width="100px">
                <el-form-item label="行业名称：" required>
                    <el-input size="medium" v-model="addHrEditForm.IndustryName" placeholder="请输入行业名称"></el-input>
                </el-form-item>
                <el-form-item label="是否一级：" required>
                    <el-radio-group size="medium" v-model="addHrEditForm.IsFirstLevel">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="父级：" required v-if="!addHrEditForm.IsFirstLevel">
                    <el-select 
                        size="medium" 
                        placeholder="请选择" 
                        v-model="addHrEditForm.ParentId" 
                        filterable
                        style="width: 100%;"
                    >
                        <el-option
                            v-for="(item,index) in industryParentList"
                            :label="item.name" 
                            :value="item.id"
                            :key="index"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注：">
                    <el-input size="medium" type="textarea" v-model="addHrEditForm.Remark" placeholder="请输入内容"></el-input>
                </el-form-item>
                <el-form-item>
                    <template v-if="industryTitle == '添加'">
                        <el-button type="primary" size="medium" @click="addInsertIndustry">确 定</el-button>
                    </template>
                    <template v-else>
                        <el-button type="primary" size="medium" @click="editUpdateIndustry">保 存</el-button>
                    </template>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {
    managerIndustryList,         //行业列表
    updateIndustryStatus,       //修改行业状态
    industryParent,             //获取父级行业
    insertIndustry,             //添加行业
    updateIndustry,             //编辑保存
} from "@/service/dataFrame";
import { getActionData } from '@/utils/store'
  export default {
    data() {
        return {
            actionData: JSON.parse(getActionData()),      //功能按钮每个页面必须用
            listLoading: false,
            form: {
                PageIndex: 1,
                PageSize: 10,

                SortNo: '',         //序列
                IndustryName: '',   //行业名称
                Id: '',             //行业ID
                IsFirstLevel: '',   //是否一级类别
                IsAvailable: '',    //是否有效
            },
            addHrEditForm: {
                Id: '',             //编辑用
                IndustryName: '',   //行业名称
                IsFirstLevel: null,   //是否一类级别 true / false
                ParentId: '',       //父级行业ID
                Remark: '',         //备注
            },
            searchData:{},
            oraginForm:{},
            total: 0,                       //总条数

            oraginSubForm:{},       
            
            tableData:[],

            industryShow: false,
            industryTitle: '',
            industryParentList: [],         //父级option
        }
    },
    activated(){
        this.handleSearch()
    },
    created() {
        this.oraginForm = JSON.parse(JSON.stringify(this.form))
        this.oraginSubForm = JSON.parse(JSON.stringify(this.addHrEditForm))
        this.tableData = [];
    },
    computed: {
    },
    mounted() {
    },
    methods: {
         //渲染列表
        handleSearch() {
            this.searchData = Object.assign({}, this.form)
            this.handleCurrentChange(1)
        },
        handleCurrentChange(val) {
            if (this.listLoading) return
            this.form.PageIndex = val
            this.searchData.PageIndex = val
            this.GetManagerIndustryList()
        },
        //翻页
        handleSizeChange(val) {
        if (this.listLoading) return
            this.form.PageIndex = 1
            this.form.PageSize = val
            this.searchData.PageIndex = 1
            this.searchData.PageSize = val
            this.GetManagerIndustryList()
        },
        //获取行业列表
        async GetManagerIndustryList(){
            this.listLoading = true
            let data = JSON.parse(JSON.stringify(this.searchData))

            !data.SortNo && delete data.SortNo
            !data.IndustryName && delete data.IndustryName
            !data.Id && delete data.Id
            if(data.IsFirstLevel === '') {
                data.IsFirstLevel = -1
            }
            if(data.IsAvailable === '') {
                data.IsAvailable = -1
            }
            data.platform = 'pcweb'
            let res = await managerIndustryList(data)
            this.listLoading = false
            if(res.Result != 1) {
                return this.$message.error('获取失败请联系开发人员')
            }
            this.tableData = res.Data.List
            this.total = res.Data.TotalRows
        },
        handleReset() {
            this.form = JSON.parse(JSON.stringify(this.oraginForm))
            this.handleSearch()
        },
        // 添加按钮
        addIndustryBox(){
            this.industryShow = true;
            this.industryTitle = '添加'
            this.addHrEditForm = JSON.parse(JSON.stringify(this.oraginSubForm))
            this.getIndustryParent()
        },
        // 获取父级行业
        getIndustryParent(){
            let data = {
                platform: 'pcweb',
                parentID: 0
            }
            industryParent(data).then(res=> {
                this.industryParentList = res.Data
            })
        },
        // 是否有效或无效
        updateIndustry(id,is){
            let data = {}
            data.IndustryID = id
            data.IsAvailable = is
            updateIndustryStatus(data).then(res=> {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success('操作成功！')
                this.GetManagerIndustryList();
            })
        },
        // 新增行业
        addInsertIndustry(){
            let data = JSON.parse(JSON.stringify(this.addHrEditForm))
            if(!data.IndustryName) {
                return this.$message.warning('行业名称不能为空')
            }
            if(data.IsFirstLevel == null) {
                return this.$message.warning('请选择是否一级')
            }
            if(data.IsFirstLevel) {
                data.ParentId = ''
            }else {
                if(!data.ParentId) {
                    return this.$message.warning('请选择父级')
                }
            }
            delete data.Id
            insertIndustry(data).then(res=> {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success(res.Message)
                this.industryShow = false;
                this.GetManagerIndustryList();
            })
        },
        // 编辑按钮
        editIndustryBox(row){
            this.industryShow = true;
            this.industryTitle = '编辑'
            this.getIndustryParent()
            let rowObj = JSON.parse(JSON.stringify(row))
            console.log(rowObj)
            this.$nextTick(()=> {
                if(!rowObj.ParentId) {
                    rowObj.ParentId = ''
                }
                this.addHrEditForm = rowObj
            })
        },
        // 编辑保存
        editUpdateIndustry(){
            let data = JSON.parse(JSON.stringify(this.addHrEditForm))
            if(!data.IndustryName) {
                return this.$message.warning('行业名称不能为空')
            }
            if(data.IsFirstLevel == null) {
                return this.$message.warning('请选择是否一级')
            }
            if(data.IsFirstLevel) {
                data.ParentId = ''
            }else {
                if(!data.ParentId) {
                    return this.$message.warning('请选择父级')
                }
            }
            updateIndustry(data).then(res=> {
                if(res.Result != 1) {
                    return this.$message.error(res.Message)
                }
                this.$message.success(res.Message)
                this.industryShow = false;
                this.GetManagerIndustryList();
            })
        },
    }
  }
</script>

<style lang="scss">
    .el-row {
        margin-bottom: 20px;
        &:last-child {
        margin-bottom: 0;
        }
    }
    .row-bg {
        padding: 10px 14px;
        background-color: #f9fafc;
    }
</style>